import { getIsQuizOpen } from '@bridebook/web/lib/quiz/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';

const AtYourVenueQuizLazy = lazyComponent(
  () => import('@bridebook/web/components/quiz/at-your-venue-quiz/at-your-venue-quiz'),
);

const AtYourVenueQuiz = () => {
  const isQuizOpen = useSelector(getIsQuizOpen('atYourVenue'));

  if (!isQuizOpen) {
    return null;
  }

  return <AtYourVenueQuizLazy />;
};

export default AtYourVenueQuiz;
